import { VPPStatusTypes } from '../VPP.types';

export const VPPStatusSerializers = {};
